/* eslint-disable */
import { FILTER_NUMBER_OF_DAYS_SELECTED } from '../Filters.types';

/**
 * Action to update the `numberOfDays` in the filters
 * @param {number} numberOfDays The number of days
 * @returns {ActionCreator<FromPayload<number, ActionMeta, FILTER_NUMBER_OF_DAYS_SELECTED>>} The created `Action`
 */
const filtersNumberOfDaysSelected = (numberOfDays) => ({ fromPayload }) => {
  return fromPayload(numberOfDays, { debounce: true }, FILTER_NUMBER_OF_DAYS_SELECTED);
};

export default filtersNumberOfDaysSelected;
